'use client'

import { useEffect, useState } from 'react'
import { getApps, initializeApp } from 'firebase/app'
import type { User } from 'firebase/auth'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyDeOWLJIFL9MaewaaxiQ8D9XZaE7j72gpg',
  authDomain: 'tigo-459217.firebaseapp.com',
  projectId: 'tigo-459217',
  storageBucket: 'tigo-459217.firebasestorage.app',
  messagingSenderId: '501760122254',
  appId: '1:501760122254:web:208149c430cf27b48358df',
  measurementId: 'G-ZXZXDNS3BS',
}

// Initialize Firebase only if it hasn't been initialized already
const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]

// Initialize Firebase Auth
export const auth = getAuth(app)

// Initialize Firebase Storage
export const storage = getStorage(app)

interface FirebaseProviderProps {
  children: React.ReactNode
}

export default function FirebaseProvider({ children }: FirebaseProviderProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-indigo-600"></div>
      </div>
    )
  }

  return <>{children}</>
}